import "./facebookBtn.css"
import fbBtn from "../../images/icon/facebook.png"
const FbBtn = ({ fblink }) => {
  return (
    <div className="fbBtn">
      <a href={fblink} target="_blank">
        <img src={fbBtn} alt="" />
      </a>
    </div>
  )
}

export default FbBtn
